import { FieldType } from "@common/dto/field/type";

const textFieldDimensions = {
  width: 150,
  height: 23,
};
const tableFieldDimensions = {
  width: 150,
  height: 100,
};

export const textElementDimensions = {
  width: 100,
  height: 50,
};

export const DATASHEET_DEFAULT_FIELDS_DIMENSIONS: Record<FieldType, { width: number; height: number }> = {
  [FieldType.system]: textFieldDimensions,
  [FieldType.text]: textFieldDimensions,
  [FieldType.date]: textFieldDimensions,
  [FieldType.number]: textFieldDimensions,
  [FieldType.checkbox]: textFieldDimensions,
  [FieldType.dropdown]: textFieldDimensions,
  [FieldType.image]: textFieldDimensions,
  [FieldType.lookupTable]: tableFieldDimensions,
  [FieldType.table]: tableFieldDimensions,
  [FieldType.computed]: textFieldDimensions,
  [FieldType.summary]: textFieldDimensions,
  [FieldType.tableSummary]: tableFieldDimensions,
  [FieldType.hyperlink]: textFieldDimensions,
  [FieldType.integer]: textFieldDimensions,
};
